export default {
  Powered: `
    <tr>
        <td>Initiative</td>
        <td>
            Prédisposition à agir de manière autonome, sans stimulation externe particulière, également dans le but d’optimiser le travail ou d’éviter/anticiper les problèmes.
        </td>
    </tr>
    <tr>
        <td>Énergie</td>
        <td>
            Faire preuve de passion et de dynamisme dans les activités menées, en s’engageant constamment dans les tâches assignées et en transmettant de l’enthousiasme aux personnes environnantes.
        </td>
    </tr>
    <tr>
        <td>Prise de décision</td>
        <td>
            Tendance à opérer résolument même dans les contextes d’ambiguïté ou en l’absence d’informations définies, en fuyant les situations d’impasse.
        </td>
    </tr>
    <tr>
        <td>Objectif</td>
        <td>
            Aspirer à des résultats appréciables, en concentrant ses énergies pour surmonter des
difficultés croissantes en tenant compte des normes partagées.
        </td>
    </tr>
    <tr>
        <td>Prise de risque</td>
        <td>
            Démarrer rapidement de nouvelles activités, même dans des conditions dépourvues d’informations, en prenant des risques basés sur l’expérience et l’intuition, tout en conservant la responsabilité des résultats.
        </td>
    </tr>
    <tr>
        <td>Persévérance</td>
        <td>
            Capacité à mettre en œuvre des comportements axés sur le maintien de l’engagement pour atteindre les objectifs personnels et de groupe, en ne reculant pas devant les difficultés..
        </td>
    </tr>
    `,
  Leader: `
      <tr>
        <td>Capacité à impliquer</td>
        <td>
          Capacité à générer une suite, à canaliser son énergie et celle de ses collaborateurs vers une vision déterminée, en surmontant les éventuels moments de difficulté.
        </td>
      </tr>
      <tr>
        <td>Communication efficace</td>
        <td>
          La capacité à expliquer et à décrire quelque chose ou à convaincre les autres à travers une présentation ou un discours, en partageant efficacement les informations et en utilisant efficacement les canaux non verbaux.
        </td>
      </tr>
      <tr>
        <td>Persuasion</td>
        <td>
          La capacité de communication visant à convaincre les autres de l’exactitude et de la positivité de leurs positions et de leurs opinions.
        </td>
      </tr>
      <tr>
        <td>Capacité à motiver</td>
        <td>
          Capacité à orienter les comportements des autres afin d’atteindre un objectif commun.
        </td>
      </tr>
      <tr>
        <td>Intelligence émotionnelle</td>
        <td>
          Capacité à reconnaître, utiliser, comprendre et gérer consciemment ses propres émotions et celles des autres.
        </td>
      </tr>
      <tr>
        <td>Vision stratégique</td>
        <td>
          Capacité à définir des objectifs et à indiquer les moyens, les instruments et les actions pour les atteindre dans une perspective à moyen/long terme.
        </td>
      </tr>
    `,
  Accurate: `
      <tr>
        <td>Analyse et synthèse</td>
        <td>
          Capacité à lire et à décoder les informations données sous forme écrite et/ou verbale, en recherchant activement des éléments utiles pour approfondir et décomposer les problèmes rencontrés.
        </td>
      </tr>
      <tr>
        <td>Exactitude</td>
        <td>
          Inclinaison à produire des résultats de qualité en termes de détails et de précision, en prenant soin des détails et ne se limitant pas à la seule exécution de la tâche assignée.
        </td>
      </tr>
      <tr>
        <td>Résolution de problèmes</td>
        <td>
          La capacité à fournir des solutions alternatives possibles à un problème, en fournissant des solutions concrètes qui optimisent les tâches et les flux de travail en réponse aux contraintes existantes.
        </td>
      </tr>
      <tr>
        <td>Flexibilité</td>
        <td>
          Savoir s’adapter à des situations différentes et à des changements de contexte, en montrant l’aptitude à la comparaison avec des idées différentes de la sienne et la disponibilité à réorganiser sa pensée sur la base de nouvelles informations.
        </td>
      </tr>
      <tr>
        <td>Organisation</td>
        <td>
          Gérer les différentes tâches en planifiant et en coordonnant les processus de manière à optimiser l’utilisation des ressources disponibles.
        </td>
      </tr>
      <tr>
        <td>Créativité</td>
        <td>
          Tendance à formuler de nombreuses réponses à un même problème et à concevoir des solutions originales, en brisant les schémas et en éloignant la conventionnalité.
        </td>
      </tr>
    `,
  Easy: `
      <tr>
        <td>Collaboration</td>
        <td>
          Travailler efficacement avec les collègues et le groupe, avec les clients internes/externes, en intégrant les différents rôles pour atteindre les objectifs communs.
        </td>
      </tr>
      <tr>
        <td>Soutien</td>
        <td>
          Capacité à écouter activement, à comprendre les besoins de ses collègues et à les soutenir dans toutes les circonstances.
        </td>
      </tr>
      <tr>
        <td>Résilience</td>
        <td>
          Résister, faire face et réorganiser positivement sa vie après avoir subi un événement négatif ou un risque, en saisissant les opportunités même dans les situations négatives car capable de gérer le changement.
        </td>
      </tr>
      <tr>
        <td>Orientation client</td>
        <td>
          Identifier et répondre aux besoins du client (à la fois interne et externe) pour construire, gérer et développer une relation de fidélisation à long terme.
        </td>
      </tr>
      <tr>
        <td>Capacités relationnelles</td>
        <td>
          Capacité à interagir avec des tiers et à saisir la position de l’interlocuteur afin d’entreprendre des relations aussi équilibrées que possible.
        </td>
      </tr>
      <tr>
        <td>Intégrité</td>
        <td>
          Agir dans le respect des règles d’un contexte spécifique, en respectant les principes éthiques et les obligations morales, en faisant preuve d’une attitude caractérisée par la franchise, la compréhension et l’intérêt pour les autres.
        </td>
      </tr>
    `,
};
